export default "__VITE_ASSET__DqYfB2Hn__"